<div class="modal-header">
  <button type="button" class="close" ng-click="$ctrl.close()">&times;</button>
  <h3 class="modal-title">Erro - aplicações prévias</h3>
</div>

<div class="modal-body">
  <h4>Existe uma ou mais aplicações com datas anteriores pendentes</h4>
  <table class="table no-margin table-scroll table-striped">
    <tbody>
      <tr ng-repeat-start="aplicacao in $ctrl.aplicacoesPrevias | orderBy: 'aplicacao.created_at' track by $index">
        <td colspan="4">
          {{aplicacao.responseFromApi.message}}
        </td>
      </tr>

      <tr ng-repeat-end>
        <td colspan="4" ng-hide="aplicacao.aplicacao">
          <small>Ações indisponíveis. Verifique se o seu usuário tem acesso a propriedade</small>
        </td>

        <td class="text-left" ng-show="aplicacao.aplicacao">
          <strong class="title">{{aplicacao.aplicacao.propriedade.descricao | characters:23}}</strong>
          <br ng-if="aplicacao.aplicacao.gleba.id">
          <strong><small>{{aplicacao.aplicacao.gleba.descricao | characters:30}}</strong></small>
          <br>
          <small>{{aplicacao.aplicacao.usuario.nome | capitalize}}</small>
        </td>

        <td class="text-left" ng-show="aplicacao.aplicacao">
          <strong class="title">{{aplicacao.aplicacao.tipo_operacao}}</strong>&nbsp;
          <i class="information fa text-muted fa-info-circle" aria-hidden="true" tipped tipped-template="tooltip-aplicacao-modal.html"></i><br>
          <small>{{aplicacao.aplicacao.created_at | date:'dd/MM \'às\' HH:mm'}}</small>
        </td>

        <td class="text-right" style="min-width: 155px" ng-if="permissions.usuario.CAN_AUDIT_PULVERIZATION" ng-show="aplicacao.aplicacao">
          <span ng-if="aplicacao.aplicacao.status_processando == 'P' || aplicacao.aplicacao.status_processando == 'R'" class="label label-warning status-processamento">
            PROCESSANDO
          </span>
          <div ng-if="!aplicacao.aplicacao.status_processando || aplicacao.aplicacao.status_processando == 'E'">
            <button ng-click="$ctrl.aplicacaoOptions(aplicacao.aplicacao)" class="btn btn-white btn-sm" type="button" title="Opções" ng-disabled="aplicacao.aplicacao.loaderAprove">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </button>
            <button class="btn btn-info btn-sm" type="button" title="Aprovar" ng-click="$ctrl.approveApplication($event, aplicacao.aplicacao)" ng-disabled="aplicacao.aplicacao.loaderAprove">
              <i ng-hide="aplicacao.aplicacao.loaderAprove" class="fa fa-check"></i>
              <span ng-show="aplicacao.aplicacao.loaderAprove">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </button>
            <button ng-click="$ctrl.goToAplicacao(aplicacao.aplicacao)" class="btn btn-default btn-sm" type="button" title="Editar">
              <i class="glyphicon glyphicon-pencil"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

</div>
<script type="text/ng-template" id="tooltip-aplicacao-modal.html">
  <div>
    <h5 class="text-center" ng-if="aplicacao.aplicacao.sementes.origem.descricao">
      {{aplicacao.aplicacao.sementes.origem.descricao}}
      <span ng-if="aplicacao.aplicacao.sementes.destino.descricao">
        » {{aplicacao.aplicacao.sementes.destino.descricao}}
      </span>
    </h5>

    <p class="text-left">
      Cultura: <strong>{{aplicacao.aplicacao.cultura.descricao | capitalize}}</strong><br>

      <span ng-if="aplicacao.aplicacao.auditoria_aplicacao.aplicacao.tanques">
        Tanques aplicados: <strong>{{aplicacao.aplicacao.auditoria_aplicacao.aplicacao.nr_tanques | number:1}}</strong><br>
      </span>

      <span ng-if="aplicacao.aplicacao.auditoria_aplicacao.aplicacao.area">
        Área aplicada: <strong>{{aplicacao.aplicacao.auditoria_aplicacao.aplicacao.area | number:2}} ha</strong><br>
      </span>

      <span ng-if="aplicacao.aplicacao.auditoria_aplicacao.aplicacao.objeto.quantidade">
        Total tratado: <strong>{{aplicacao.aplicacao.auditoria_aplicacao.aplicacao.objeto.quantidade | number:2}} kg</strong><br>
      </span>

      Data de aplicação:
      <strong>
        {{$ctrl.formatMomentDate(aplicacao.aplicacao.auditoria_aplicacao.aplicacao.dt_ini ||
          aplicacao.aplicacao.auditoria_aplicacao.aplicacao.objeto.atributo_attributes.data_hora_inicio)}} -
        {{$ctrl.formatMomentDate(aplicacao.aplicacao.auditoria_aplicacao.aplicacao.dt_fim ||
          aplicacao.aplicacao.auditoria_aplicacao.aplicacao.objeto.atributo_attributes.data_hora_fim)}}
      </strong><br/>

      Produtos:
      <strong ng-repeat="produto in aplicacao.aplicacao.produtos track by $index">
        <br>
        {{produto.descricao}} <span ng-if="aplicacao.aplicacao.tipo_operacao_enum !== 'operacao_tratamento_semente'">- Dose: {{(produto.dose || 0) | formatDynamicDecimals}} {{produto.unidade.abreviatura}}/ha</span> - Total: {{(produto.quantidadeTotal || 0) | formatDynamicDecimals}}
      </strong><br>

      Operador:
      <strong>
        {{aplicacao.aplicacao.usuario.nome | capitalize}}
      </strong><br>

      Responsáveis pela aprovação:
      <strong>
        <responsavel-aprovacao propriedade="aplicacao.aplicacao.propriedade" tipo="pulverizacao"></responsavel-aprovacao>
      </strong>
    </p>
  </div>
</script>

